module.exports = __webpack_public_path__ + "media/22.3034abd1.mp3";